import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon/Icon'
import Button from '../Button/Button'
import Container from '../Container/Container'

export const Root = styled.span`
  position: relative;
  display: inline-block;
  font-size: 16px;
`

export const Arrow = styled.span`
  /* position: absolute;
    width: 0;
    height: 0;
    left: ${ (props) =>
    props.arrow === 'left'
      ? '10px'
      : props.arrow === 'middle'
      ? '50%'
      : 'auto' };
    right: ${ (props) => (props.arrow === 'right' ? '10px' : 'auto') }; */

  /* margin-top: -5px; */
  /* margin-left: -5px; */

  &::before {
    position: absolute;
    top: 1px;
    left: ${ (props) =>
      props.arrow === 'left'
        ? '10px'
        : props.arrow === 'middle'
        ? '50%'
        : 'auto' };
    right: ${ (props) => (props.arrow === 'right' ? '10px' : 'auto') };
    transform: ${ (props) =>
      props.arrow === 'middle' ? 'translateX(-50%)' : 'none' };
    content: '';
    border-width: 0 8px 8px;
    border-style: solid;
    border-color: transparent;
    border-bottom-color: ${ (props) => props.theme.colors['aok-gruen'] };
  }

  &::after {
    position: absolute;
    top: 2px;
    left: ${ (props) =>
      props.arrow === 'left'
        ? '10px'
        : props.arrow === 'middle'
        ? '50%'
        : 'auto' };
    right: ${ (props) => (props.arrow === 'right' ? '10px' : 'auto') };
    transform: ${ (props) =>
      props.arrow === 'middle' ? 'translateX(-50%)' : 'none' };
    content: '';
    border-width: 0 8px 8px;
    border-style: solid;
    border-color: transparent;
    border-bottom-color: ${ (props) => props.theme.colors.weiss };
  }
`

export const TooltipContainer = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${ (props) => props.theme.zIndices.overlay };
  padding-top: 8px;
`

export const TooltipContent = styled.span`
  display: block;
  width: 100%;
  padding: 15px;
  background-color: #fff;
  border: 1px solid ${ (props) => props.theme.colors['aok-gruen'] };
  font-size: 16px;
  line-height: 1.56;
  white-space: normal;
  max-width: 270px;
`

export const InfoIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors.hellgruen1 };
  display: flex;
  outline: none;
`

export const Backdrop = styled.span`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: ${ (props) => props.theme.zIndices.overlay };
`

export const DialogContainer = styled((props) => <Container { ...props } />)`
  position: fixed;
  z-index: ${ (props) => props.theme.zIndices.modal };
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 350px;
  background: #fff;
`

export const DialogTitle = styled.span`
  display: flex;
  justify-content: center;
  padding: 20px 20px 10px 20px;
`

export const DialogInfoIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors['aok-gruen'] };
  margin-right: 10px;
`

export const DialogContent = styled.span`
  width: 100%;
  display: block;
  padding: 15px 10px;
`

export const DialogButton = styled((props) => <Button { ...props } />)`
  width: 100%;
  text-decoration: underline;
  line-height: 1.44;
  color: #303030;
  background: #fff;
  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(0, 0, 0, 0.03);
    color: #303030;
    text-decoration: underline;
  }

  &:focus {
    background: rgba(0, 0, 0, 0.03);
    color: #303030;
    text-decoration: underline;
  }
`

export const IconWrapper = styled.span`
  display: block;
`
